export const userColumns = [
  {
    field: "lastName",
    headerName: "Nom(s)",
    width: 150,
  },
  {
    field: "firstName",
    headerName: "Prénom(s)",
    width: 150,
  },
  {
    field: "email",
    headerName: "Email",
    width: 200,
  },
  {
    field: "phone",
    headerName: "Téléphone",
    width: 150,
  },
  {
    field: "theme",
    headerName: "Thème",
    width: 300,
  }
];

export const adminColumns = [
  {
    field: "displayName",
    headerName: "Nom complet",
    width: 250,
  },
  {
    field: "email",
    headerName: "Email",
    width: 200,
  },
  {
    field: "phone",
    headerName: "Téléphone",
    width: 150,
  },
  {
    field: "city",
    headerName: "Ville",
    width: 100,
  },
  {
    field: "country",
    headerName: "Pays",
    width: 100,
  }
];

export const examColumns = [
  {
    field: "displayName",
    headerName: "Nom complet",
    width: 250,
  },
  {
    field: "email",
    headerName: "Email",
    width: 200,
  },
  {
    field: "theme",
    headerName: "Thème",
    width: 200,
  },
  {
    field: "phone",
    headerName: "Téléphone",
    width: 150,
  },
  {
    field: "city",
    headerName: "Ville",
    width: 100,
  },
  {
    field: "country",
    headerName: "Pays",
    width: 100,
  }
];

export const postColumns = [
  {
    field: "img",
    headerName: "Cover",
    width: 70,
    renderCell: (params) => {
      return (
        <div className="cellWithImg2">
          <img className="cellImg" src={params.row.img} alt="cover" />
        </div>
      );
    },
  },
  { field: "title", headerName: "Titre", width: 180 },
  {
    field: "content",
    headerName: "Content",
    width: 350,
  },
  {
    field: "author",
    headerName: "Par",
    width: 150
  }
];
